import OriginPagination from './Pagination';

export type PaginationProps = typeof OriginPagination & {};
const Pagination = OriginPagination as PaginationProps;

export { Pagination };
